import type { Options } from "react-hotkeys-hook";
import { useKeyboardShortcuts } from "../Hooks/useKeyboardShortcuts";

export interface KeyboardShortcutsProps {
  options?: Options;
}

export const KeyboardShortcuts = ({ options }: KeyboardShortcutsProps) => {
  useKeyboardShortcuts(options);

  return null;
};
